<app-header></app-header>
<app-cart-header></app-cart-header>
<div class="main-body">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
